import React from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@material-ui/core";
import { FieldAttributes, useField, FieldArray, Field } from "formik";
import { useTranslation } from "react-i18next";

type UploadSexSelectProps = {
  label: string;
} & FieldAttributes<{}>;

export const UploadSexSelect: React.FC<UploadSexSelectProps> = props => {
  const [field] = useField<{}>(props);
  const { t } = useTranslation();

  return (
    <div>
      <FieldArray name={props.name}>
        {arrayHelpers => (
          <FormControl fullWidth margin="normal">
            <InputLabel id={props.name + "-label"}>{props.label}</InputLabel>
            <Field
              fullWidth
              type="select"
              as={Select}
              labelId={props.name + "-label"}
              {...field}
              {...props}
            >
              <MenuItem key="male" value="M">
                {t("step4.sex.male")}
              </MenuItem>
              <MenuItem key="female" value="F">
                {t("step4.sex.female")}
              </MenuItem>
              <MenuItem key="other" value="O">
                {t("step4.sex.other")}
              </MenuItem>
            </Field>
          </FormControl>
        )}
      </FieldArray>
    </div>
  );
};
